/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Intake_Why_Date_Of_Birth_ShortInputs */

const en_us2_intake_why_date_of_birth_short = /** @type {(inputs: Intake_Why_Date_Of_Birth_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Age sets the safe ramp`)
};

const pt_br2_intake_why_date_of_birth_short = /** @type {(inputs: Intake_Why_Date_Of_Birth_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A idade define o ritmo seguro`)
};

const es_419_intake_why_date_of_birth_short = /** @type {(inputs: Intake_Why_Date_Of_Birth_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La edad define el ritmo seguro`)
};

const pt_pt2_intake_why_date_of_birth_short = /** @type {(inputs: Intake_Why_Date_Of_Birth_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A idade define o ritmo seguro`)
};

const fr_fr2_intake_why_date_of_birth_short = /** @type {(inputs: Intake_Why_Date_Of_Birth_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'âge fixe un rythme sûr`)
};

const de_de2_intake_why_date_of_birth_short = /** @type {(inputs: Intake_Why_Date_Of_Birth_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das Alter bestimmt das sichere Tempo`)
};

const it_it2_intake_why_date_of_birth_short = /** @type {(inputs: Intake_Why_Date_Of_Birth_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'età fissa la progressione sicura`)
};

/**
* | output |
* | --- |
* | "Age sets the safe ramp" |
*
* @param {Intake_Why_Date_Of_Birth_ShortInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const intake_why_date_of_birth_short = /** @type {((inputs?: Intake_Why_Date_Of_Birth_ShortInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Intake_Why_Date_Of_Birth_ShortInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_intake_why_date_of_birth_short(inputs)
	if (locale === "es-419") return es_419_intake_why_date_of_birth_short(inputs)
	if (locale === "pt-PT") return pt_pt2_intake_why_date_of_birth_short(inputs)
	if (locale === "fr-FR") return fr_fr2_intake_why_date_of_birth_short(inputs)
	if (locale === "de-DE") return de_de2_intake_why_date_of_birth_short(inputs)
	if (locale === "it-IT") return it_it2_intake_why_date_of_birth_short(inputs)
	return en_us2_intake_why_date_of_birth_short(inputs)
});
export { intake_why_date_of_birth_short as "intake.why.date_of_birth.short" }